import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var MultiPartDataClass;
function MultiPartData() {
  if (MultiPartDataClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MultiPartData', VOID, VOID, VOID, [0]);
    MultiPartDataClass = $;
  }
  return MultiPartDataClass;
}
//region block: exports
export {
  MultiPartData as MultiPartData57syw40llxls,
};
//endregion

//# sourceMappingURL=Multipart.mjs.map
